export default "/dist/files/commentaire_new.5843906cd9c7d7c92c7a21402246c385.svg";